






import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PopupType } from '@/store/module/ui';

const ui = namespace('UI');

@Component
export default class PopupOverlay extends Vue {
  public test = true;

  @ui.State
  public popup!: PopupType | null;
}
